export default __webpack_public_path__ + "static/media/LOGO_GLOBALMOVE.33a012cf.png";